import PropertyIcons from './PropertyIcons';
import { getIconClassName } from '@uifabric/styling/lib/index';
var classname = require('classnames');
var styles = require('./propertyIcons.scss');
export default function getPropertyIcon(propertyIcon) {
    switch (propertyIcon) {
        case PropertyIcons.GlobalMentionedMe:
            return classname(styles.accounts, getIconClassName("Accounts" /* Accounts */));
        case PropertyIcons.Attachment:
            return getIconClassName("Attach" /* Attach */);
        case PropertyIcons.ImportanceLow:
            return getIconClassName("Down" /* Down */);
        case PropertyIcons.ImportanceHigh:
            return classname(styles.redDark, getIconClassName("Important" /* Important */));
        case PropertyIcons.Like:
            return getIconClassName("Like" /* Like */);
        case PropertyIcons.Snooze:
            return classname(styles.snooze, getIconClassName("Clock" /* Clock */));
        case PropertyIcons.MailListViewReplied:
            return getIconClassName("Reply" /* Reply */);
        case PropertyIcons.MailListViewForwarded:
            return getIconClassName("Forward" /* Forward */);
        case PropertyIcons.MailListViewIRM:
            return classname(styles.redDark, getIconClassName("Drm" /* Drm */));
        case PropertyIcons.MailListViewIRMReplied:
            return classname(styles.redDark, getIconClassName("IRMReply" /* IRMReply */));
        case PropertyIcons.MailListViewIRMForwarded:
            return classname(styles.redDark, getIconClassName("IRMForward" /* IRMForward */));
        case PropertyIcons.MailListViewVoiceMailItem:
            return getIconClassName("Memo" /* Memo */);
        case PropertyIcons.MailListViewVoiceMailReplied:
            return getIconClassName("VoicemailReply" /* VoicemailReply */);
        case PropertyIcons.MailListViewVoiceMailForwarded:
            return getIconClassName("VoicemailForward" /* VoicemailForward */);
        case PropertyIcons.MailListViewVoiceMailIRM:
            return getIconClassName("VoicemailIRM" /* VoicemailIRM */);
        case PropertyIcons.MailListViewFaxItem:
            return getIconClassName("Fax" /* Fax */);
        case PropertyIcons.MailListViewAppointmentItem:
            return getIconClassName("Event" /* Event */);
        case PropertyIcons.MailListViewAppointmentAccepted:
            return getIconClassName("EventAccepted" /* EventAccepted */);
        case PropertyIcons.MailListViewAppointmentDeclined:
            return getIconClassName("EventDeclined" /* EventDeclined */);
        case PropertyIcons.MailListViewAppointmentTentative:
            return getIconClassName("EventTentative" /* EventTentative */);
        case PropertyIcons.MailListViewAppointmentCanceled:
            return getIconClassName("RemoveEvent" /* RemoveEvent */);
        case PropertyIcons.MailListViewContactItem:
            return getIconClassName("ContactCard" /* ContactCard */);
        case PropertyIcons.MailListViewTaskItem:
            return getIconClassName("CheckboxComposite" /* CheckboxComposite */);
        case PropertyIcons.MailListViewTaskReocurItem:
            return getIconClassName("RecurringTask" /* RecurringTask */);
        case PropertyIcons.MailListViewJournalItem:
            return getIconClassName("DietPlanNotebook" /* DietPlanNotebook */);
        case PropertyIcons.MailListViewPostItem:
            return getIconClassName("NotePinned" /* NotePinned */);
        case PropertyIcons.MailListViewNoteItem:
            return getIconClassName("QuickNote" /* QuickNote */);
        case PropertyIcons.MailListViewDelivery:
            // Bug 1752 - culture specific
            return getIconClassName("ReceiptForward" /* ReceiptForward */);
        case PropertyIcons.MailListViewNonDelivery:
            // Bug 1752 - culture specific
            return getIconClassName("ReceiptReply" /* ReceiptReply */);
        case PropertyIcons.MailListViewApprovalRequest:
            // add sprite response_request.png
            return getIconClassName("ReceiptReply" /* ReceiptReply */);
        case PropertyIcons.MailListViewResponseApprove:
            // add sprite response_approve.png
            return getIconClassName("ReceiptReply" /* ReceiptReply */);
        case PropertyIcons.MailListViewResponseReject:
            // add sprite response_reject.png
            return getIconClassName("ReceiptReply" /* ReceiptReply */);
        case PropertyIcons.MailListViewOutOfOffice:
            // Bug 1752 - culture specific
            return getIconClassName("OutOfOffice" /* OutOfOffice */);
        case PropertyIcons.MailListViewReadReport:
            return getIconClassName("ReceiptCheck" /* ReceiptCheck */);
        case PropertyIcons.MailListViewReminderMessage:
            return getIconClassName("Ringer" /* Ringer */);
        default:
            throw new Error('No CSS class icon for the given property icon');
    }
}
//# sourceMappingURL=getPropertyIconStyle.js.map